import { mapValues } from "lodash-es";
import { VARIABLE_CONSTANTS } from "@wms/variables";

export const dataChangeTemplate: any = {
    'service': 'DatabaseService',
    'operation': 'operation',
    'params': {
        'data': {},
        'dataModelName': 'dataModelName',
        'entityName': 'entityName'
    },
    'hasError': 0,
    'errorMessage': ''
};

export const changeLogSet: any = {
    'total': 0,
    'database': {
        'create': [dataChangeTemplate],
        'update': [dataChangeTemplate],
        'delete': [dataChangeTemplate]
    },
    'uploads': [{
        'service': 'OfflineFileUploadService',
        'operation': 'uploadToServer',
        'params': {
            'file': 'localFilePath',
            'serverUrl': 'serverUrl',
            'ftOptions': {}
        },
        'hasError': 0,
        'errorMessage': ''
    }]
};

export const defaultFileTypesToOpen: any = {
    'doc': { 'label': 'Microsoft Office Word Document', 'mimeType': 'application/msword', 'extension': 'doc' },
    'pdf': { 'label': 'PDF Document', 'mimeType': 'application/pdf', 'extension': 'pdf' },
    'ppt': { 'label': 'Microsoft Office Powerpoint', 'mimeType': 'application/vnd.ms-powerpoint', 'extension': 'ppt' },
    'xls': { 'label': 'Microsoft Office Excel', 'mimeType': 'application/vnd.ms-excel', 'extension': 'xls' }
};

export const barcodeFormatOptions: any = {
    "ALL": "ALL",
    "CODABAR": "CODABAR (not supported in iOS)",
    "CODE_39": "CODE_39",
    "CODE_93": "CODE_93 (not supported in iOS)",
    "CODE_128": "CODE_128",
    "DATA_MATRIX": "DATA_MATRIX",
    "EAN_8": "EAN_8",
    "EAN_13": "EAN_13",
    "ITF": "ITF",
    "PDF_417": "PDF_417 (not supported in iOS)",
    "QR_CODE": "QR_CODE",
    "RSS14": "RSS14 (not supported in iOS)",
    "RSS_EXPANDED": "RSS_EXPANDED (not supported in iOS)",
    "UPC_E": "UPC_E",
    "UPC_A": "UPC_A"
};

export const REQUIRED_PLUGINS: any[] = ['OFFLINE_DB', 'NETWORK'];

export const contactsModelMeta: any = {
    'id': {
        fieldName: 'id',
        type: 'integer',
        value: ''
    },
    'displayName': {
        fieldName: 'displayName',
        type: 'string',
        value: ''
    },
    'phoneNumbers': {
        fieldName: 'phoneNumbers',
        type: 'array',
        value: [{ value: '' }]
    }
};

export const calendarModelMeta: any = { // setting the type of fields
    'title': {
        fieldName: 'title',
        type: 'string',
        value: ''
    },
    'message': {
        fieldName: 'message',
        type: 'string',
        value: ''
    },
    'location': {
        fieldName: 'location',
        type: 'string',
        value: ''
    },
    'startDate': {
        fieldName: 'startDate',
        type: 'date',
        value: ''
    },
    'endDate': {
        fieldName: 'endDate',
        type: 'date',
        value: ''
    }
};

export const deviceOperations: any = {
    'calendar': {
        createEvent: {
            properties: [
                { "target": "eventTitle", "type": "string", "dataBinding": true },
                { "target": "eventNotes", "type": "string", "dataBinding": true },
                { "target": "eventLocation", "type": "string", "dataBinding": true },
                { "target": "eventStart", "type": "datetime", "dataBinding": true },
                { "target": "eventEnd", "type": "datetime", "dataBinding": true }
            ],
            requiredCordovaPlugins: ['CALENDAR'],
            requiredNativePlugins: ['CALENDAR']
        },
        deleteEvent: {
            properties: [
                { "target": "eventTitle", "type": "string", "dataBinding": true },
                { "target": "eventLocation", "type": "string", "dataBinding": true },
                { "target": "eventNotes", "type": "string", "dataBinding": true },
                { "target": "eventStart", "type": "datetime", "dataBinding": true },
                { "target": "eventEnd", "type": "datetime", "dataBinding": true }
            ],
            requiredCordovaPlugins: ['CALENDAR'],
            requiredNativePlugins: ['CALENDAR']
        },
        getEvents: {
            model: [mapValues(calendarModelMeta, 'value')],
            properties: [
                { "target": "eventTitle", "type": "string", "dataBinding": true },
                { "target": "eventLocation", "type": "string", "dataBinding": true },
                { "target": "eventNotes", "type": "string", "dataBinding": true },
                { "target": "eventStart", "type": "datetime", "dataBinding": true },
                { "target": "eventEnd", "type": "datetime", "dataBinding": true },
                { "target": "startUpdate", "type": "boolean" },
                { "target": "autoUpdate", "type": "boolean" }
            ],
            requiredCordovaPlugins: ['CALENDAR'],
            requiredNativePlugins: ['CALENDAR']
        }
    },
    'camera': {
        captureImage: {
            model: {
                imagePath: 'resources/images/imagelists/default-image.png'
            },
            properties: [
                { "target": "allowImageEdit", "type": "boolean", "value": false, "dataBinding": true },
                { "target": "imageQuality", "type": "number", "value": 80, "dataBinding": true },
                { "target": "imageEncodingType", "type": "list", "options": { "0": "JPEG", "1": "PNG" }, "value": "0", "dataBinding": true },
                { "target": "correctOrientation", "type": "boolean", "value": true, "dataBinding": true },
                { "target": "imageTargetWidth", "type": "number", "dataBinding": true },
                { "target": "imageTargetHeight", "type": "number", "dataBinding": true }
            ],
            requiredCordovaPlugins: ['CAMERA', 'CAPTURE'],
            requiredNativePlugins: ['CAMERA']
        },
        captureVideo: {
            model: {
                videoPath: ''
            },
            properties: [],
            requiredCordovaPlugins: ['CAMERA', 'CAPTURE'],
            requiredNativePlugins: ['CAMERA']
        }
    },
    'contacts': {
        getContacts: {
            model: [mapValues(contactsModelMeta, 'value')],
            requiredCordovaPlugins: ['CONTACTS'],
            requiredNativePlugins: ['CONTACTS'],
            properties: [
                { "target": "startUpdate", "type": "boolean" },
                { "target": "autoUpdate", "type": "boolean" },
                { "target": "contactFilter", "type": "string", "value": "", "dataBinding": true }
            ]
        }
    },
    // 'datasync': {
    //     pull: {
    //         owner: VARIABLE_CONSTANTS.OWNER.APP,
    //         model: {
    //             'totalTaskCount': 0,
    //             'completedTaskCount': 0,
    //             'inProgress': false
    //         },
    //         properties: [
    //             { "target": "clearData", "type": "boolean", "widgettype": "boolean-inputfirst", "value": true, "group": "properties", "subGroup": "behavior" },
    //             { "target": "startUpdate", "type": "boolean", "hide": false },
    //             { "target": "onBefore", "hide": false },
    //             { "target": "onProgress", "hide": false },
    //             { "target": "showProgress", "hide": false }
    //         ],
    //         requiredCordovaPlugins: REQUIRED_PLUGINS
    //     },
    //     lastPullInfo: {
    //         owner: VARIABLE_CONSTANTS.OWNER.APP,
    //         model: {
    //             'databases': [{
    //                 'name': 'datbaseName',
    //                 'entities': [{
    //                     'entityName': 'entityName',
    //                     'pulledRecordCount': 0
    //                 }],
    //                 'pulledRecordCount': 0
    //             }],
    //             'totalPulledRecordCount': 0,
    //             'startTime': new Date().toJSON(),
    //             'endTime': new Date().toJSON()
    //         },
    //         properties: [
    //             { "target": "startUpdate", "type": "boolean", "value": true, "hide": true },
    //             { "target": "spinnerContext", "hide": false },
    //             { "target": "spinnerMessage", "hide": false }
    //         ],
    //         requiredCordovaPlugins: REQUIRED_PLUGINS
    //     },
    //     push: {
    //         owner: VARIABLE_CONSTANTS.OWNER.APP,
    //         model: {
    //             'successfulTaskCount': 0,
    //             'failedTaskCount': 0,
    //             'completedTaskCount': 0,
    //             'totalTaskCount': 0,
    //             'inProgress': false
    //         },
    //         properties: [
    //             { "target": "onBefore", "hide": false },
    //             { "target": "onProgress", "hide": false },
    //             { "target": "showProgress", "hide": false, "value": true }
    //         ],
    //         requiredCordovaPlugins: REQUIRED_PLUGINS
    //     },
    //     lastPushInfo: {
    //         owner: VARIABLE_CONSTANTS.OWNER.APP,
    //         model: {
    //             'successfulTaskCount': 0,
    //             'failedTaskCount': 0,
    //             'completedTaskCount': 0,
    //             'totalTaskCount': 0,
    //             'startTime': new Date().toJSON(),
    //             'endTime': new Date().toJSON()
    //         },
    //         properties: [
    //             { "target": "startUpdate", "type": "boolean", "value": true, "hide": true },
    //             { "target": "spinnerContext", "hide": false },
    //             { "target": "spinnerMessage", "hide": false }
    //         ],
    //         requiredCordovaPlugins: REQUIRED_PLUGINS
    //     },
    //     getOfflineChanges: {
    //         model: {
    //             'total': 0,
    //             'pendingToSync': changeLogSet,
    //             'failedToSync': changeLogSet
    //         },
    //         properties: [
    //             { "target": "startUpdate", "type": "boolean", "value": true, "hide": true },
    //             { "target": "autoUpdate", "type": "boolean", "value": true, "hide": true }
    //         ],
    //         requiredCordovaPlugins: REQUIRED_PLUGINS
    //     },
    //     exportDB: {
    //         model: {
    //             'path': ''
    //         },
    //         properties: [
    //             { "target": "spinnerContext", "hide": false },
    //             { "target": "spinnerMessage", "hide": false }
    //         ],
    //         requiredCordovaPlugins: REQUIRED_PLUGINS
    //     },
    //     importDB: {
    //         model: {},
    //         properties: [
    //             { "target": "spinnerContext", "hide": false },
    //             { "target": "spinnerMessage", "hide": false }
    //         ],
    //         requiredCordovaPlugins: REQUIRED_PLUGINS
    //     }
    // },
    'device': {
        getAppInfo: {
            model: {
                appversion: 'X.X.X',
                cordovaversion: 'X.X.X'
            },
            properties: [
                { "target": "startUpdate", "type": "boolean", "value": true, "hide": true }
            ]
        },
        getCurrentGeoPosition: {
            model: {
                coords: {
                    latitude: 0,
                    longitude: 0,
                    altitude: 0,
                    accuracy: 0,
                    altitudeAccuracy: 0,
                    heading: 0,
                    speed: 0
                },
                timestamp: 0
            },
            requiredCordovaPlugins: ['GEOLOCATION'],
            requiredNativePlugins: ['GEOLOCATION'],
            properties: [
                { "target": "startUpdate", "type": "boolean", "value": true, "hide": true },
                { "target": "autoUpdate", "type": "boolean", "value": true, "hide": true },
                { "target": "geolocationHighAccuracy", "type": "boolean", "value": true, "dataBinding": true },
                { "target": "geolocationMaximumAge", "type": "number", "value": 3, "dataBinding": true },
                { "target": "geolocationTimeout", "type": "number", "value": 5, "dataBinding": true }
            ]
        },
        getDeviceInfo: {
            model: {
                deviceModel: 'DEVICEMODEL',
                os: 'DEVICEOS',
                osVersion: 'X.X.X',
                deviceUUID: 'DEVICEUUID'
            },
            properties: [
                { "target": "startUpdate", "type": "boolean", "value": true, "hide": true }
            ]
        },
        getNetworkInfo: {
            model: {
                connectionType: 'NONE',
                isConnecting: false,
                isNetworkAvailable: true,
                isOnline: true,
                isOffline: false
            },
            requiredCordovaPlugins: ['NETWORK'],
            requiredNativePlugins: ['NETWORK'],
            properties: [
                { "target": "autoUpdate", "type": "boolean", "value": true, "hide": true },
                { "target": "startUpdate", "type": "boolean", "value": true, "hide": true },
                { "target": "networkStatus", "type": "boolean", value: "bind:App.networkStatus", "dataBinding": true, hide: true },
                { "target": "onOnline", "hide": false },
                { "target": "onOffline", "hide": false }
            ]
        },
        goOnline: {
            model: {},
            properties: []
        },
        goOffline: {
            model: {},
            properties: []
        },
        vibrate: {
            properties: [
                { "target": "vibrationtime", "type": "number", "value": 2, "dataBinding": true }
            ],
            requiredCordovaPlugins: ['VIBRATE'],
            requiredNativePlugins: ['VIBRATE']
        }
    },
    'file': {
        upload: {
            model: {
                'fileName': '',
                'path': '',
                'length': 0,
                'success': false,
                'inlinePath': '',
                'errorMessage': '',
                'inProgress': false,
                'loaded': 0
            },
            properties: [
                { "target": "localFile", "type": "string", "value": "", "dataBinding": true },
                { "target": "remoteFolder", "type": "string", "value": "", "dataBinding": true },
                { "target": "onProgress", "hide": false },
                { "target": "spinnerContext", "hide": false },
                { "target": "spinnerMessage", "hide": false }
            ],
            requiredCordovaPlugins: ['FILE', 'FILETRANSFER']
        },
        openFile: {
            model: {},
            properties: [
                { "target": "filePath", "type": "string", "value": "", "dataBinding": true },
                { "target": "fileType", "type": "list", "options": mapValues(defaultFileTypesToOpen, 'label'), "value": "pdf", "dataBinding": true, "hide": true },
                { "target": "spinnerContext", "hide": false },
                { "target": "spinnerMessage", "hide": false }
            ]
        }
    },
    'scan': {
        scanBarCode: {
            model: {
                text: 'BAR CODE',
                format: "TEXT",
                cancelled: false
            },
            requiredCordovaPlugins: ['BARCODE_SCANNER'],
            requiredNativePlugins: ['BARCODE_SCANNER'],
            properties: [
                {
                    "target": "barcodeFormat",
                    "type": "list",
                    "options": barcodeFormatOptions,
                    "value": "ALL",
                    "group": "properties",
                    "subGroup": "behavior",
                    "hide": false
                }
            ]
        }
    }

}

export function getDeviceOperations() {
    return deviceOperations;
}